import React from "react";

const FormGroup = ({
  label,
  name,
  id,
  onChange,
  error,
  placeHolder,
  type,
  value,
}) => {
  return (
    <div className="flex flex-col gap-1 mb-3 2xl:mb-6">
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeHolder}
        className="rounded-[0.675rem] placeholder-[#BDBDBD] border-[1px] px-5 py-3 border-[#BDBDBD] ring-0 outline-0 focus:border-[#393939] focus:ring-0 focus:outline-0"
      />
      <small className="text-red-600 ">{error}</small>
    </div>
  );
};

export default FormGroup;
